var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"aiInto",staticClass:"ai_into_wrap",class:[{ hidebox: _vm.scrollHideBox, showbox: !_vm.scrollHideBox }],on:{"click":function($event){return _vm.goAi()}}},[_c('img',{staticClass:"ai_into",attrs:{"src":require("@/assets/img/activity/ai/ai.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }